import { Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { PageContext } from "../PageContext";
import StyledButton, { ButtonStyle } from "../../../components/StyledButton";
import { ColorHexCodes } from "../../../util/Color";

type RouteButtonData = {
  style: ButtonStyle,
  text: string,
  path?: string
}

export default function SettingListPage({ pageContext }: { pageContext: PageContext }) {
  const api = pageContext.api;

  if (!api) {
    return <>IndexedDBが使用出来ません。ブラウザが対応していない場合があります。IndexedDBに対応している最新のブラウザを使用してください。</>
  }

  const pages: RouteButtonData[] = [
    { style: "primary", text: "工事情報の事前ダウンロード (オフライン作業用)", path: "cache/" },
  ];

  return (
    <Stack width="100%" alignItems="center">
      <Stack p="32px" maxWidth={800} width="100%" gap="21.6px">
        <Typography fontSize={27} fontWeight="bold" lineHeight={1}>設定一覧</Typography>
        <Stack gap="36.7px">
          { pages.map((page, index) => <SettingPageNavButton key={`setting-nav-${index}`} pageContext={pageContext} buttonData={page} />)}
        </Stack>
      </Stack>
    </Stack>
  );
}

function SettingPageNavButton({ pageContext, buttonData }: { pageContext: PageContext, buttonData?: RouteButtonData }) {
  const navigate = useNavigate();
  const buttonSx = { px: 2, flex: 1, boxShadow: 3, backgroundColor: `#${ColorHexCodes.White}`};

  if (!buttonData) {
    return (
      <Stack flex={1} px={2}/>
    )
  }

  const handleClick = (data: RouteButtonData) => {
    if (!data.path) {
      pageContext.api.showError("こちらは現在未実装の機能です。");
      return;
    }
    navigate(data.path);
  };

  return (
    <StyledButton buttonStyle={buttonData.style} size="large" onClick={() => handleClick(buttonData)} sx={buttonSx}>
      <Stack alignContent="center" gap="16.5px" height={40} justifyContent="center">
        <Typography fontSize={20} fontWeight="bold">{buttonData.text}</Typography>
      </Stack>
    </StyledButton>
  );
}
